// Deliberately excludes cart, order, store and age-gate preferences.
const AUTH_KEYS = [
  'access_token',
  'refresh_token',
  'token_expires_at',
  'catalystUserId',
  'alpine_iq_id',
  'first_name',
  'last_name',
  'email',
  'phone',
  'dob',
];
export function clearLoginState() {
  for (const name of AUTH_KEYS) {
    document.cookie = `${name}=; path=/; max-age=0; SameSite=Lax`;
    localStorage.removeItem(name);
  }
}
